import {BehaviorSubject, Observable, of} from 'rxjs';
import {PageResult} from '../../shared/page-result';
import {AuthService} from '../auth.service';
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {catchError, finalize} from 'rxjs/operators';
import {BaseFilterDto} from './base-filter-dto';
import {BaseUserTableService} from './base-user-table.service';

export abstract class BaseTableDataSource<T, F extends BaseFilterDto> implements DataSource<T> {

  private collections = new BehaviorSubject<T[]>([]);
  private loadingState = new BehaviorSubject<boolean>(false);
  private pageState = new BehaviorSubject<PageResult<T>>(this.getInitPage());

  protected constructor(protected authService: AuthService) {
  }

  getLoadingState(): Observable<boolean> {
    return this.loadingState.asObservable();
  }

  getPageState(): Observable<PageResult<T>> {
    return this.pageState.asObservable();
  }

  connect(collectionViewer: CollectionViewer): Observable<T[]> {
    return this.collections.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.collections.complete();
    this.loadingState.complete();
    this.pageState.complete();
  }

  loadCollections(pageNumber = 1, pageSize = 10, sort = 'id', sortOrder = 'asc', filter: F = this.getInitFilter(), clear: boolean = true) {
    this.collections.next([]);
    this.loadingState.next(true);
    this.authService.getToken().then(token => {
      this.getUserService().findList(pageNumber - 1, pageSize, sort, sortOrder, token, filter)
        .pipe(
          catchError(() => of([])),
          finalize(() => this.loadingState.next(false))
        )
        .subscribe((currentPage: PageResult<T>) => {
          this.pageState.next(currentPage);
          if (clear) {
            this.collections.next(currentPage.content);
          } else {
            this.collections.value.push(...currentPage.content);
          }
        });
    });
  }

  protected abstract getInitFilter(): F;

  protected abstract getUserService(): BaseUserTableService<T, F>;

  protected getInitPage(): PageResult<T> {
    return {content: [], first: true, last: true, number: 0, numberOfElements: 0, size: 0, sort: [], totalElements: 0, totalPages: 0};
  }

}
